import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {RichIcon, Flex, Text, Section} from 'components/UIKit';
import * as locales from './locales';
import * as styles from './HowExchange.scss';

interface HowExchangeProps {}

function HowExchangeComponent({i18n}: HowExchangeProps & WithI18nProps) {
  return (
    <Section
      heading={i18n.translate('howHeading')}
      subhead={i18n.translate('howSubHeading')}
      headingProps={{align: 'center', inheritColor: true}}
      subheadProps={{align: 'center', inheritColor: true}}
      className={styles.Wrapper}
    >
      <ul className={styles.Cards}>
        {locales.en.items.map((item, index) => (
          <Flex wrapperComponent="li" key={item.icon} className={styles.Card}>
            <RichIcon icon={item.icon} size={40} className={styles.Icon} />
            <Flex direction="column">
              <Text
                type="h3"
                component="p"
                text={i18n.translate(`items.${index}.heading`)}
                className={styles.ContentHeading}
              />
              <Text
                text={i18n.translate(`items.${index}.content`)}
                component="p"
                secondary
                resetMargin
              />
            </Flex>
          </Flex>
        ))}
      </ul>
    </Section>
  );
}

export const HowExchange = withI18n({
  fallback: locales.en,
  id: 'HowExchange',
})(HowExchangeComponent);
